import React from "react"
import { DataGrid } from "@mui/x-data-grid"
import { SHIPPING_COLUMNS } from "../../constants/columns"
import { ShippingEntry } from "../../types"
import { Box, Button, Typography } from "@mui/material"
import { AddCircleOutline } from "@mui/icons-material"

const MainGridList = () => {
  // This is where you'll fetch or receive your data
  const [rows] = React.useState<ShippingEntry[]>([])

  return (
    <>
      <Box
        sx={{
          height: "100vh",
          width: "100%",
          p: 2,
          display: "flex",
          flexDirection: "column"
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
          <Typography variant="h5" component="h2">
            Main Grid
          </Typography>
          <Button variant="contained" startIcon={<AddCircleOutline />}>
            Add Main Grid
          </Button>
        </Box>
        <Box sx={{ flexGrow: 1 }}>
          <DataGrid
            rows={rows}
            columns={SHIPPING_COLUMNS}
            getRowId={(row) => `${row.sno}-${row.containerNos}`}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 25 }
              }
            }}
            density="compact"
            pageSizeOptions={[25, 50, 100]}
            checkboxSelection
            disableRowSelectionOnClick
            sx={{
              height: "100%",
              border: (theme) => `1px solid ${theme.palette.divider}`,
              "& .MuiDataGrid-cell": {
                borderTop: (theme) => `1px solid ${theme.palette.divider}`
              },
              "& .MuiDataGrid-cell:focus": {
                outline: "none"
              },
              "& .MuiDataGrid-row:hover": {
                backgroundColor: "action.hover"
              }
            }}
          />
        </Box>
      </Box>
    </>
  )
}

export default MainGridList
